export const CUSTOMER_STANDARD_ROLES = {
  MAIN: 'main',
  LIMITED: 'limited',
  SALES_AGENT: 'sales-agent',
  SALES_ADMIN: 'sales-admin',
} as const;

export const CUSTOMER_ROLE_TYPE = {
  CUSTOMER: 'customer',
  SALES: 'sales',
} as const;

export const EXCLUDED_DEFAULT_SALES_AGENT_EMAIL = 'shopify@sparklayer.io';
